import { makeStateKey } from "@angular/core";
import { HandledHttpResponse } from "@uzenith360/http-utils";
import Order from "./types/order.interface";

export default makeStateKey<HandledHttpResponse<Order>>('order-data');